module.exports = __webpack_public_path__ + "assets/732fe5cc816ca5a65acd9c8709e28fdc.png";